import { Typography, styled } from "@mui/material";
import { calendarDayName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "highlightToday"]);
const Label = styled(Typography, {
  name: calendarDayName,
  slot: "label",
  overridesResolver: (_, styles) => [styles.root],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ ownerState, highlightToday }) => {
  const isToday = ownerState?.day.type === "day" && ownerState.day.isToday;
  return {
    ...isToday && highlightToday && {
      fontWeight: "bold",
      textDecoration: "underline"
    },
    userSelect: "none",
    pointerEvents: "none"
  };
});
export {
  Label
};
//# sourceMappingURL=Label.js.map
